// extracted by mini-css-extract-plugin
module.exports = {"IconWithNotifications":"IconWithNotifications_IconWithNotifications__WKT6Y","notification":"IconWithNotifications_notification__38hl4","icon":"IconWithNotifications_icon__2HyIh"};